 export const skillsData =[
    {
        label: "FRONT END",
        data:[
            {
                skillName: "HTML",
                percentage: "90"
            },
            {
                skillName: "CSS",
                percentage: "85"
            },
            {
                skillName: "JAVASCRIPT",
                percentage: "70"
            },
            {
                skillName: "REACT.JS",
                percentage: "75"
            },
            {
                skillName: "BOOTSTRAP",
                percentage: "80"
            },
            {
                skillName: "TAILWIND",
                percentage: "50"
            },
            
        ]
    },
    {
        label: "BACK END",
        data:[
            {
                skillName: "NODE.JS",
                percentage: "60"
            },
            {
                skillName: "EXPRESS.JS",
                percentage: "60"
            }
            
        ]
    },

    {
        label: "DATABASES",
        data:[
            {
                skillName: "SQL",
                percentage: "65"
            },
            {
                skillName: "MONGODB",
                percentage: "75"
            }
            
        ]
    }
]
